import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ProfileLayout from 'components/ProfileLayout'
import Loader from 'components/Loader'
import useUser from 'hooks/api/useUser'
import useContentHitContract from 'hooks/useContentHitContract'
import InviteToPoolSidebar from 'pages/Network/components/InviteToPoolSidebar'
import { Content } from 'types/app'
import s from './index.module.scss'
import { createCustomer } from 'api/user'
import { getUser, setUser } from 'helpers/storage'
import Meta from 'components/Meta'
const Profile = (): JSX.Element | null => {
	const { userId } = useParams()
	const { user, isLoading } = useUser(userId)

	useContentHitContract(
		userId && user
			? ({
				ContentId: user?.ContentId,
			} as Content)
			: undefined,
		undefined,
		'Customer',
	)

	const createAnonymousCustomer = async (): Promise<void> => {
		const response = await createCustomer('Customer', 'Anonymous')
		setUser(response.Properties)
	}
	useEffect(() => {
		const user = getUser()
		if (!user) createAnonymousCustomer()
	}, [])

	useEffect(() => {
		if (user?.ContentTitle) document.title = user?.ContentTitle + ' Portfolio'

		return () => {
			document.title = 'Showrealz - Where talent meets opportunity'
		}
	}, [user?.ContentTitle])
	if (!user && !isLoading) return null

	return (
		<>
			<Meta title={(user as any)?.CustomUserName}>
				<meta property="og:title" content={(user as any)?.CustomUserName} />
				<meta property="og:description" content={user?.CustomUserBiography || ' '} />
				<meta
					property="og:image"
					content={user?.CustomerImageSquareUrl || ''}
				/>
				<meta property="og:image:width" content="300" />
				<meta property="og:image:height" content="300" />
				<meta property="og:image:type" content="image/jpeg" />
				<meta property="og:type" content="profile" />
			</Meta>

			<Loader loading={isLoading} />

			{user && (
				<div className={s.container}>
					<InviteToPoolSidebar />
					<ProfileLayout user={user} />
				</div>
			)}
		</>
	)

}

export default Profile
